import axios from "axios";

export const state = {
    schedules: [],
};

export const getters = {
    schedules: state => state.schedules,
};

export const mutations = {
    setSchedules(state, newValue) {
        state.schedules = newValue
    },
};

export const actions = {
    fetchSchedules({ commit }) {
        axios.get('/schedules').then(res => {
            commit('setSchedules', res.data.schedules)
        })
    },
};
